export default "__VITE_ASSET__DlH3BBNe__"